import { trackingClient } from "@utilitywarehouse/tracking-core";
import {
  snowplowAdapter,
  client,
} from "@utilitywarehouse/tracking-adapter-snowplow-web";

import { env } from "../../../env";

const snowplowTracker = trackingClient({
  adapters: [
    snowplowAdapter({
      collector:
        env.isProductionHost || env.isDevelopmentHost
          ? "https://c.uw.co.uk"
          : "https://uk-co-uw-prod1.collector.snplow.net",
      appId: "customer_support",
      trackerName: `customer_support_vulnerability${
        !env.isProductionHost ? `_dev` : ""
      }`,
    }),
  ],
});

export const snowplowClient = client;

export default snowplowTracker;
